
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Controlador as Model } from '../../controlador';
    import { Wait } from '@/__env/ext';
import { Viajante } from '@/__env/lib/Ventas/Viajantes/Viajante.nav';

    @Component( {
        name: "Componente",
        props: {},
        components: {
        }
    } )
    export default class Componente extends Vue
    {
        public get Controlador() { return Model; }
        public Estado: 'cargando' | 'ok' | 'vacio' = 'vacio';

        public Seleccionado: number = -1;
        @Watch( 'Seleccionado' )
        onSeleccionado()
        {


        }



        public Busqueda: string = '';
        @Watch( 'Busqueda' )
        public async Buscar()
        {
            if ( !this.Busqueda )
                return;

            let b = this.Busqueda;
            await Wait( 500 );
            if ( this.Busqueda != b )
                return;

            if ( this.Estado == 'cargando' )
                return;

            this.Estado = 'cargando';
            this.$emit( 'busqueda', this.Busqueda );
            let e = await Viajante.find( { q: this.Busqueda } );
            this.Seleccionado = -1;
            this.Items = e.Items;
            this.Estado = 'ok';
        }

        public Resaltar( x: string )
        {
            return x.toUpperCase().replace( this.Busqueda.toUpperCase(), `<b>${this.Busqueda.toUpperCase()}</b>` );
        }

        public Seleccionar( x: Viajante)
        {
            this.Controlador.ViajanteSeleccionado = x;
            this.Controlador.Vista.Modo = 'viajante';
        }

        private items: Viajante[] = [];
        public get Items(): Viajante[]
        {
            return this.items;
        }

        public set Items( a: Viajante[] )
        {
            this.items = a;
        }


        protected Eventos: Function[] = [];
        beforeDestroy() { this.Eventos.forEach( x => x() ); }
        mounted()
        {


        }

    }
